module.exports = __webpack_public_path__ + "static/media/gt1.dc39f61a.png";